import { render, staticRenderFns } from "./FurnitureItem.vue?vue&type=template&id=93e75030&scoped=true&"
import script from "./FurnitureItem.vue?vue&type=script&lang=js&"
export * from "./FurnitureItem.vue?vue&type=script&lang=js&"
import style0 from "./FurnitureItem.vue?vue&type=style&index=0&id=93e75030&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93e75030",
  null
  
)

export default component.exports